module.exports = __webpack_public_path__ + "img/vietnam_rounded.65370d33.png";